import { ThemeProvider } from '@emotion/react';
import EditOutlined from '@mui/icons-material/EditOutlined';
import NearMeOutlined from '@mui/icons-material/NearMeOutlined';
import NotificationsIcon from '@mui/icons-material/NotificationsNoneOutlined';
import VerifiedUser from '@mui/icons-material/VerifiedUser';

import IconButton from '@mui/material/IconButton';
import { handleFollowing } from 'APIs/utils';

import { useAppSelector } from 'app/hooks';
import NormalButton from 'components/atoms/Button/NormalButton';
import SmallIconButton from 'components/atoms/Button/SmallIconButton';
import StatusButton from 'components/atoms/Button/StatusButton';
import {
  HeaderUserDropZoneCards,
  UserDropZoneCards,
} from 'components/molecules/Card/DropZone';
import FollowUserModal from 'components/molecules/FollowModal';
import { NotificationContext } from 'context';
import { selectAuth } from 'features/auth/authSlice';
import { UserData, UserProfileData } from 'interfaces/UserData.interface';
import * as React from 'react';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { onContact } from 'utils/Firebase.util';
import { v4 } from 'uuid';
import MenuIcon from '@mui/icons-material/Menu';

import {
  AboutText,
  BackgroundBox,
  ButtonGroupBox,
  colortheme,
  EditLayer,
  EditText,
  FollowTextBox,
  FollowTitleText,
  GuestText,
  HeaderBar,
  Layer1,
  Layer2,
  Layer2Left,
  Layer2LeftBottom,
  Layer2LeftTop,
  Layer2Right,
  Layer3,
  Layer4,
  Layer5,
  Layer6,
  Layer7,
  ParaText,
  SiteText,
  StyledBadge,
  tabButtonStyles,
  TitleText,
  WhiteTextField,
} from './styles';
import HamburgerMenu from 'components/organisms/Footer/MobileGlobalFooter/HamburgerMenu';

type ContentType = {
  gall: boolean;
  coll: boolean;
  back: boolean;
  badges: boolean;
  collected : boolean;
};

type opinionType = {
  contact: string;
  follow: string;
};

const ProfileHeader: React.FC<{
  Gallery?: any;
  Backstage?: any;
  Collector?: any;
  Badge?: any;
  Feed?: any;
  Collected?: any;
  data: UserProfileData;
}> = ({ Gallery, Backstage, Collected,Collector, Badge, Feed, data }) => {
  const useravatar = require('assets/Profile/buku_default_avatar.png');
  const profileHeadBack = require('assets/Profile/buku_default_banner.png');

  const [contentPage, setContentPage] = React.useState<ContentType>({
    gall: true,
    coll: false,
    back: false,
    badges: false,
    collected : false
  });
  const { setPreviewPage } = useContext(NotificationContext);
  const authState = useAppSelector(selectAuth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [opinionState, setOpinionState] = React.useState<opinionType>({
    contact: 'yellow',
    follow: 'none',
  });
  const [following, setFollowing] = React.useState<boolean>(false);
  const [, setUserName] = React.useState<string>('');
  const [, setUserSiteUrl] = React.useState<string>('');
  const [, setUserAbout] = React.useState<string>('');

  const [NameEditable, setNameEditable] = React.useState<boolean>(false);
  const [aboutEditable, setAboutEditable] = React.useState<boolean>(false);
  const [siteEditable, setSiteEditable] = React.useState<boolean>(false);
  const [avatarEditable, setAvatarEditable] = React.useState<boolean>(false);
  const [bannerEditable, setBannerEditable] = React.useState<boolean>(false);
  const [, SetUserHeader] = React.useState<any>(data.banner);
  const [, setImageUrl] = React.useState<any>(data.avatar);
  const [isOtherUser, setIsOtherUser] = React.useState<boolean>(false);
  const history = useNavigate();

  React.useEffect(() => {
    const userType = (): void => {
      setIsOtherUser(authState.id !== data.id);
    };
    userType();
  }, [authState.id, data.id]);

  const handleFollowUser = async () => {
    if (isOtherUser && data.followers) {
      if (following) {
        data.followers = data.followers.filter(
          follower => follower.follower.id !== authState.id
        );
      } else {
        data.followers.push({
          id: v4(),
          followedAt: new Date(),
          followedDate: new Date(),
          follower: authState as UserData,
          following: data as UserData,
        });
      }
      handleFollowing({
        authState,
        data: data as UserData,
        following,
        setFollowing,
        dispatch,
      });
    }
  };

  const getFollowLength = React.useCallback(
    (type: 'followers' | 'following') => {
      if (type === 'followers') {
        if (isOtherUser && data.followers) {
          return data.followers.length;
        } else if (authState.followers && !isOtherUser) {
          return authState.followers.length;
        }
      } else {
        if (isOtherUser && data.following) {
          return data.following.length;
        } else if (authState.following && !isOtherUser) {
          let unfollowLength = 0;
          authState.following.forEach(
            following => following.unfollowed && unfollowLength++
          );
          return authState.following.length - unfollowLength;
        }
      }
    },
    [
      authState.following,
      authState.followers,
      data.followers,
      data.following,
      isOtherUser,
    ]
  );

  React.useEffect(() => {
    const getFollowing = () => {
      if (authState && authState.following) {
        authState.following.some(
          following =>
            following.following.id === data.id && !following.unfollowed
        ) && setFollowing(true);
      }
    };
    getFollowing();
    //eslint-disable-next-line
  }, [authState.following, data]);

  const clickGall = (): void => {
    setContentPage({
      gall: true,
      coll: false,
      back: false,
      badges: false,
      collected: false,
    });
    Gallery();
    // history("/profile/gallery");
  };
  const clickColl = (): void => {
    setContentPage({
      gall: false,
      coll: true,
      back: false,
      badges: false,
      collected: false,
    });
    history('/createfund');
  };
  const clickBack = (): void => {
    setContentPage({
      gall: false,
      coll: false,
      back: true,
      badges: false,
      collected: false,
    });
    Backstage();
    // history("/profile/backstage/paywall");
  };
  const clickBadges = (): void => {
    setContentPage({
      gall: false,
      coll: false,
      back: false,
      badges: true,
      collected: false,
    });
  };
  const clickCollected = (): void => {
    setContentPage({
      gall: false,
      coll: false,
      back: false,
      badges: false,
      collected: true,
    });
    Collected()
    
  };

  const setContactTrue = async () => {
    setOpinionState({ contact: 'yellow', follow: 'none' });
    await onContact(authState, data, dispatch, navigate, true);
  };

  const SetUserAvatar = (url: any): void => {
    setImageUrl(url);
  };

  const gotoNotification = (): void => {
    history('/notification');
    setPreviewPage('profile/gallery');
  };

  React.useEffect(() => {
    if (data.name && data.banner && data.avatar && data.bio) {
      SetUserHeader(data.banner);
      setImageUrl(data.avatar);
      setUserName(data.name);
      setUserAbout(data.bio || '');
    }
  }, [data]);
  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <HeaderBar>
          <BackgroundBox>
            {bannerEditable ? (
              <HeaderUserDropZoneCards
                SetHeader={SetUserHeader}
                style={{ height: '188px' }}
              />
            ) : (
              <img
                src={data.banner ? data.banner : profileHeadBack}
                alt="header back"
                style={{
                  width: '100%',
                  height: '188px',
                  position: 'absolute',
                  objectFit: 'cover',
                }}
              />
            )}
          </BackgroundBox>
          <Layer1>
            <div
              style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
              }}
            >
              <IconButton
                size="large"
                aria-label="show 17 new notifications"
                sx={{ padding: 'unset', color: '#ffffff', marginRight: '20px' }}
              >
                <StyledBadge
                  overlap="circular"
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  variant="dot"
                >
                  <div onClick={() => gotoNotification()}>
                    <NotificationsIcon
                      sx={{ fontSize: 'larger', color: '#ffffff' }}
                    />
                  </div>
                </StyledBadge>
              </IconButton>
              <IconButton
                size="large"
                aria-label="near me"
                color="secondary"
                sx={{ padding: 'unset' }}
              >
                <div onClick={() => history('/message')}>
                  <NearMeOutlined
                    sx={{ fontSize: 'larger', color: '#ffffff' }}
                  />
                </div>
              </IconButton>
              <IconButton
                sx={{ padding: 'unset', color: '#ffffff', marginLeft: '20px' }}
              >
                <HamburgerMenu>
                  <MenuIcon />
                </HamburgerMenu>
              </IconButton>
            </div>
          </Layer1>
          <Layer2>
            <Layer2Right>
              {!avatarEditable ? (
                <img
                  src={data.avatar ? data.avatar : useravatar}
                  alt="user"
                  style={{
                    borderRadius: '50%',
                    width: '100%',
                    height: '100%',
                  }}
                />
              ) : (
                <UserDropZoneCards SetAvatar={SetUserAvatar} />
              )}
            </Layer2Right>
            <Layer2Left>
              {authState.username === data.username && (
                <Layer2LeftTop>
                  {!aboutEditable ? (
                    <EditLayer
                      onClick={() => {
                        setAboutEditable(true);
                        setSiteEditable(true);
                        setNameEditable(true);
                        setAvatarEditable(true);
                        setBannerEditable(true);
                      }}
                    >
                      <EditOutlined />
                      <EditText>Edit profile</EditText>
                    </EditLayer>
                  ) : (
                    <EditLayer
                      onClick={() => {
                        setAboutEditable(false);
                        setSiteEditable(false);
                        setNameEditable(false);
                        setAvatarEditable(false);
                        setBannerEditable(false);
                      }}
                    >
                      <EditOutlined />
                      <EditText>Save profile</EditText>
                    </EditLayer>
                  )}
                </Layer2LeftTop>
              )}
              <Layer2LeftBottom>
                <FollowTextBox>
                  <FollowUserModal
                    type="followers"
                    data={data}
                    isOtherUser={isOtherUser}
                    updateComponent={handleFollowUser}
                  >
                    <FollowTitleText>
                      {getFollowLength('followers')}
                    </FollowTitleText>
                  </FollowUserModal>
                  <ParaText>followers</ParaText>
                </FollowTextBox>
                <FollowTextBox>
                  <FollowUserModal
                    type="following"
                    data={data}
                    isOtherUser={isOtherUser}
                    updateComponent={handleFollowUser}
                  >
                    <FollowTitleText>
                      {getFollowLength('following')}
                    </FollowTitleText>
                  </FollowUserModal>
                  <ParaText>following</ParaText>
                </FollowTextBox>
              </Layer2LeftBottom>
            </Layer2Left>
          </Layer2>

          <Layer3>
            {!NameEditable ? (
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <TitleText>{data.username}</TitleText>
                <VerifiedUser
                  sx={{ fontSize: '17px', padding: '5px 5px 0px 7px' }}
                />
              </div>
            ) : (
              <WhiteTextField
                multiline
                autoFocus
                value={data.username}
                onChange={event => setUserName(event.target.value)}
              />
            )}

            {/* <SmallButton color={'none'} text={userBanner} /> */}
            {/* {!bannerEditable ? (
              <SmallButton color={"none"} text={userBanner} />
            ) : (
              <WhiteTextField
                multiline
                autoFocus
                value={userBanner}
                onChange={(event) => setUserBanner(event.target.value)}
              />
            )} */}
          </Layer3>

          <Layer4>
            {!siteEditable ? (
              <SiteText>{data.website}</SiteText>
            ) : (
              <WhiteTextField
                style={{ width: '100%' }}
                multiline
                value={data.website}
                onChange={event => setUserSiteUrl(event.target.value)}
              />
            )}
            {!aboutEditable ? (
              <AboutText>{data.bio}</AboutText>
            ) : (
              <WhiteTextField
                style={{ width: '100%' }}
                multiline
                value={data.bio}
                onChange={event => setUserAbout(event.target.value)}
              />
            )}
          </Layer4>
          {isOtherUser && (
            <Layer5>
              <div onClick={() => setContactTrue()}>
                <SmallIconButton
                  text={'contact'}
                  color={opinionState.contact}
                  isClicked={true}
                  type={'contact'}
                />
              </div>
              <div onClick={() => handleFollowUser()}>
                {following ? (
                  <SmallIconButton
                    text={'unfollow'}
                    color={'yellow'}
                    isClicked={true}
                    type={'following'}
                  />
                ) : (
                  <SmallIconButton
                    text={'Follow'}
                    color={opinionState.follow}
                    isClicked={true}
                    type={'follow'}
                  />
                )}
              </div>
            </Layer5>
          )}
          <Layer6>
            <StatusButton text={'13%'} type={'chart'} />
            <StatusButton text={'1.3k'} type={'finger'} />
            <StatusButton text={'12.9k'} type={'play'} />
            <StatusButton text={'310'} type={'graph'} />
          </Layer6>
          <Layer7>
            <GuestText>Click on a statistic to know more</GuestText>
          </Layer7>
        </HeaderBar>
        <ButtonGroupBox>
          <Swiper
            slidesPerView={'auto'}
            spaceBetween={20}
            pagination={{
              clickable: true,
            }}
            className="mySwiper"
            style={{ paddingRight: '50px', paddingLeft: '40px' }}
          >
            <SwiperSlide style={{ width: 'fit-content' }}>
              {' '}
              <div onClick={() => clickGall()}>
                <NormalButton
                  text={'Gallery'}
                  color={'sky'}
                  isClicked={contentPage.gall}
                  style={tabButtonStyles}
                />
              </div>
            </SwiperSlide>
            <SwiperSlide style={{ width: 'fit-content' }}>
              <div onClick={() => clickCollected()}>
                <NormalButton
                  text={'Collected'}
                  color={'sky'}
                  isClicked={contentPage.collected}
                  style={tabButtonStyles}
                />
              </div>
            </SwiperSlide>
            <SwiperSlide style={{ width: 'fit-content' }}>
              <div onClick={() => clickColl()}>
                <NormalButton
                  text={'My collectors'}
                  color={'sky'}
                  isClicked={contentPage.coll}
                  style={tabButtonStyles}
                />
              </div>
            </SwiperSlide>
            <SwiperSlide style={{ width: 'fit-content' }}>
              <div onClick={() => clickBack()}>
                <NormalButton
                  text={'Backstage'}
                  color={'sky'}
                  isClicked={contentPage.back}
                  style={tabButtonStyles}
                />
              </div>
            </SwiperSlide>
            <SwiperSlide style={{ width: 'fit-content' }}>
              <div onClick={() => clickBadges()}>
                <NormalButton
                  text={'Badges'}
                  color={'sky'}
                  isClicked={contentPage.badges}
                  style={tabButtonStyles}
                />
              </div>
            </SwiperSlide>
          </Swiper>
        </ButtonGroupBox>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default ProfileHeader;
